import React, { useState } from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  padding: 2rem;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f0f0f0;
`;

const ModalTitle = styled.h2`
  margin: 0;
  color: #333;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #333;
  }
`;

const LineInfo = styled.div`
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1.5rem;
`;

const LineLabel = styled.div`
  font-size: 0.875rem;
  color: #666;
  margin-bottom: 0.25rem;
`;

const LineValue = styled.div`
  font-weight: 600;
  color: #333;
`;

const NotesTextarea = styled.textarea`
  width: 100%;
  min-height: 150px;
  padding: 0.75rem;
  border: 2px solid #e0e0e0;
  border-radius: 4px;
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  margin-bottom: 1.5rem;

  &:focus {
    outline: none;
    border-color: #2196F3;
  }

  &::placeholder {
    color: #999;
  }
`;

const ModalActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
`;

const CancelButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    background: #5a6268;
  }
`;

const SaveButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    background: #1976D2;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const CharCount = styled.div`
  font-size: 0.875rem;
  color: #666;
  text-align: right;
  margin-top: -1rem;
  margin-bottom: 1rem;
`;

const LineNotesModal = ({ lineData, onClose, onSave }) => {
  const [notes, setNotes] = useState(lineData.notes || '');
  const maxLength = 500;

  const handleSave = () => {
    onSave(notes);
  };

  const firstComponent = lineData.components[0];
  const dimensions = firstComponent.width && firstComponent.height
    ? `${firstComponent.width} × ${firstComponent.height} cm`
    : '';

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>
            📝 Notas de la Línea
          </ModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>

        <LineInfo>
          <LineLabel>Línea de pedido</LineLabel>
          <LineValue>
            Marco {dimensions} × {firstComponent.quantity || 1}
          </LineValue>
          <LineLabel style={{ marginTop: '0.5rem' }}>Componentes</LineLabel>
          <LineValue>
            {lineData.components.length} componente(s)
          </LineValue>
        </LineInfo>

        <NotesTextarea
          value={notes}
          onChange={(e) => setNotes(e.target.value.slice(0, maxLength))}
          placeholder="Escribe notas o instrucciones especiales para esta línea de pedido..."
          maxLength={maxLength}
        />

        <CharCount>
          {notes.length} / {maxLength} caracteres
        </CharCount>

        <ModalActions>
          <CancelButton onClick={onClose}>Cancelar</CancelButton>
          <SaveButton onClick={handleSave}>
            Guardar Notas
          </SaveButton>
        </ModalActions>
      </ModalContent>
    </ModalOverlay>
  );
};

export default LineNotesModal;
